const loaded = new Set<string>();
const pending = new Map<string, Promise<void>>();

export const isUrlLoaded = (url?: string): boolean => (!!url && loaded.has(url));

// Single shared loader per URL - components and the eager preloader both call
// this, so the same image is never requested twice in parallel.
export const loadUrl = (url?: string): Promise<void> => {
    if (!url) return Promise.resolve();
    if (loaded.has(url)) return Promise.resolve();

    let promise = pending.get(url);
    if (!promise) {
        promise = new Promise<void>(resolve => {
            const img = new Image();
            img.onload = img.onerror = () => {
                loaded.add(url);
                pending.delete(url);
                resolve();
            };
            img.src = url;
        });
        pending.set(url, promise);
    }
    return promise;
};
